/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/function-component-definition */
import React, { useState } from 'react';
import { Dropdown, Button, Grid, Modal, TextInput } from '../../../../canvasComponents/index';
import './AddressModal.scss';
import { FormattedMessage, IntlProvider, useIntl } from 'react-intl';
import { stateUSA, provinceCanada, countries } from './DummyData';
// messages
import messages from './messages';

export const AddressModal = ({ type, showModal, setShowModal, setSubmitAddressModal, localParams }) => {
  const intl = useIntl();
  const [address, setAddress] = useState({
    street: '',
    streetName: '',
    city: '',
    country: 'CA',
    province: '',
    state: '',
    postalCode: '',
    zipCode: '',
  });

  const [errors, setErrors] = useState({
    errorStreetName: '',
    errorCity: '',
    errorProvince: '',
    errorState: '',
  });

  const addressHandler = (e, fieldName) => {
    if (fieldName === 'country') {
      setAddress((prevState) => ({
        ...prevState,
        [fieldName]: e,
        province: '',
        state: e !== 'CA' && e !== 'US' ? 'Other' : '',
      }));
    } else {
      setAddress((prevState) => ({
        ...prevState,
        [fieldName]: e,
      }));
    }
  };

  const translateOptions = (options) => {
    const newOptions = options.map((element) => ({
      selectedLabel: `${intl.formatMessage({ id: `${element.selectedLabel}`, defaultValue: `${element.selectedLabel}` })}`,
      label: `${intl.formatMessage({ id: `${element.label}`, defaultValue: `${element.label}` })}`,
      value: element.value,
    }));
    return newOptions;
  };

  const handleValidation = () => {
    let formIsValid = true;

    if (address.streetName.trim() === '') {
      setErrors((prevState) => ({
        ...prevState,
        errorStreetName: `${intl.formatMessage({ id: 'Oops! Looks like you forgot to fill this in.', defaultMessage: 'Oops! Looks like you forgot to fill this in.' })}`,
      }));
      formIsValid = false;
    } else {
      setErrors((prevState) => ({
        ...prevState,
        errorStreetName: '',
      }));
    }

    if (address.city.trim() === '') {
      setErrors((prevState) => ({
        ...prevState,
        errorCity: `${intl.formatMessage({ id: 'Oops! Looks like you forgot to fill this in.', defaultMessage: 'Oops! Looks like you forgot to fill this in.' })}`,
      }));
      formIsValid = false;
    } else {
      setErrors((prevState) => ({
        ...prevState,
        errorCity: '',
      }));
    }

    if (address.country === 'CA') {
      if (address.province === '') {
        setErrors((prevState) => ({
          ...prevState,
          errorProvince: `${intl.formatMessage({ id: 'Oops! Looks like you forgot to fill this in.', defaultMessage: 'Oops! Looks like you forgot to fill this in.' })}`,
        }));
        formIsValid = false;
      } else {
        setErrors((prevState) => ({
          ...prevState,
          errorProvince: '',
        }));
      }
    } else if (address.state === '') {
      setErrors((prevState) => ({
        ...prevState,
        errorState: `${intl.formatMessage({ id: 'Oops! Looks like you forgot to fill this in.', defaultMessage: 'Oops! Looks like you forgot to fill this in.' })}`,
      }));
      formIsValid = false;
    } else {
      setErrors((prevState) => ({
        ...prevState,
        errorState: '',
      }));
    }

    return formIsValid;
  };

  const saveAddress = () => {
    if (handleValidation()) {
      setSubmitAddressModal(address);
      cleanAddress(false);
    }
  };

  const cleanAddress = (closeModal) => {
    setAddress({
      street: '',
      streetName: '',
      city: '',
      country: 'CA',
      province: '',
      state: '',
      postalCode: '',
      zipCode: '',
    });
    if (closeModal) {
      setErrors({
        errorStreetName: '',
        errorCity: '',
        errorProvince: '',
        errorState: '',
      });
      setShowModal(false);
    }
  };

  return (
    showModal ? (
      <IntlProvider locale={localParams.lang} messages={localParams.i18n} intl={intl}>
        <Modal
          id="addressmodal"
          ariaHideApp={false}
          isOpen={showModal}
          onRequestClose={() => {
            setShowModal(false);
          }}
        >
          <div className="padding-sides-modal">
            <Grid>

              {type === 'Pindrop' ? (
                <Grid.Row>
                  <span className="title"><FormattedMessage {...messages.addIncident} /></span>
                  <span className="sub-title"><FormattedMessage {...messages.fillInTheForm} /></span>
                </Grid.Row>
              )
                : (
                  <Grid.Row>
                    <span className="title"><FormattedMessage {...messages.title} /></span>
                    <span className="sub-title"><FormattedMessage {...messages.subTitle} /></span>
                  </Grid.Row>
                )}
              <Grid.Row>
                <Grid.Column colMd5>
                  <label htmlFor="street" className="modal-label">
                    <FormattedMessage {...messages.street} />
                  </label>
                  <TextInput
                    name="street"
                    number
                    defaultValue={address.address}
                    onChange={(v) => addressHandler(v, 'street')}
                  />
                </Grid.Column>
                <Grid.Column colMd7>
                  <label htmlFor="streetName" className="modal-label">
                    <FormattedMessage {...messages.streetName} />
                  </label>
                  <TextInput
                    name="streetName"
                    defaultValue={address.address}
                    onChange={(v) => addressHandler(v, 'streetName')}
                  />
                  {errors.errorStreetName !== '' && (
                  <span
                    style={{
                      marginLeft: '3px',
                      fontSize: '14px',
                      color: 'rgb(177, 2, 2)',
                    }}
                  >
                    {errors.errorStreetName}
                  </span>
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6>
                  <label htmlFor="city" className="modal-label">
                    <FormattedMessage {...messages.city} />
                  </label>
                  <TextInput
                    name="city"
                    defaultValue={address.city}
                    onChange={(v) => addressHandler(v, 'city')}
                  />
                  {errors.errorCity !== '' && (
                  <span
                    style={{
                      marginLeft: '3px',
                      fontSize: '14px',
                      color: 'rgb(177, 2, 2)',
                    }}
                  >
                    {errors.errorCity}
                  </span>
                  )}
                </Grid.Column>
                <Grid.Column colMd6>
                  <label htmlFor="country" className="modal-label">
                    <FormattedMessage {...messages.country} />
                  </label>
                  <Dropdown
                    id="country"
                    name="country"
                    primary
                    value={address.country}
                    onChange={(value) => addressHandler(value, 'country')}
                    options={translateOptions(countries)}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6>
                  {address.country === 'CA' ? (
                    <>
                      <label htmlFor="province" className="modal-label"><FormattedMessage {...messages.province} /></label>
                      <Dropdown
                        id="province"
                        name="province"
                        primary
                        value={address.province}
                        onChange={(value) => addressHandler(value, 'province')}
                        options={translateOptions(provinceCanada)}
                      />
                      {errors.errorProvince !== '' && (
                      <span
                        style={{
                          marginLeft: '3px',
                          fontSize: '14px',
                          color: 'rgb(177, 2, 2)',
                        }}
                      >
                        {errors.errorProvince}
                      </span>
                      )}
                    </>
                  ) : (
                    <>
                      <label htmlFor="state"><FormattedMessage {...messages.state} /></label>
                      <Dropdown
                        id="state"
                        name="state"
                        primary
                        onChange={(value) => addressHandler(value, 'state')}
                        value={
                            address.country === 'US' ? address.state : 'Other'
                          }
                        options={
                            address.country === 'US'
                              ? stateUSA
                              : [
                                {
                                  selectedLabel: 'Other',
                                  label: 'Other',
                                  value: 'Other',
                                },
                              ]
                          }
                      />
                      {errors.errorState !== '' && (
                      <span
                        style={{
                          marginLeft: '3px',
                          fontSize: '14px',
                          color: 'rgb(177, 2, 2)',
                        }}
                      >
                        {errors.errorState}
                      </span>
                      )}
                    </>
                  )}
                </Grid.Column>
                <Grid.Column colMd6>
                  {address.country === 'CA' ? (
                    <>
                      <label htmlFor="postalCode" className="modal-label"><FormattedMessage {...messages.postalCode} /></label>
                      <TextInput
                        name="postalCode"
                        defaultValue={address.postalCode}
                        onChange={(v) => addressHandler(v, 'postalCode')}
                      />
                    </>
                  ) : (
                    <>
                      <label htmlFor="zipCode"><FormattedMessage {...messages.zipCode} /></label>
                      <TextInput
                        name="zipCode"
                        defaultValue={address.zipCode}
                        onChange={(v) => addressHandler(v, 'zipCode')}
                      />
                    </>
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Button
                  primary
                  style={{ marginTop: '20px' }}
                  id="saveAddressButton"
                  onClick={() => saveAddress()}
                >
                  <FormattedMessage {...messages.saveAddress} />
                </Button>
              </Grid.Row>
              <Grid.Row>
                <Button
                  className="black-underline-button"
                  style={{ marginTop: '20px' }}
                  id="cancelButton"
                  onClick={() => cleanAddress(true)}
                >
                  <FormattedMessage {...messages.cancel} />
                </Button>
              </Grid.Row>

            </Grid>
          </div>
        </Modal>
      </IntlProvider>
    ) : null
  );
};
